
import i18n from 'i18next'

export const fanfanloI18n = i18n;
